import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3caed390"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "innermodaloverflow" }
const _hoisted_2 = { class: "font-regular-16 btm-1" }
const _hoisted_3 = { class: "userlistdiv" }
const _hoisted_4 = {
  key: 0,
  class: "font-regular-16 breaking-words success-text"
}
const _hoisted_5 = {
  key: 1,
  class: "font-regular-16 breaking-words failure-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedAddons, (addon, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "addonlistdiv"
      }, [
        _createElementVNode("label", _hoisted_2, [
          _createTextVNode(" Add-on \""),
          _createElementVNode("strong", null, _toDisplayString(addon.productName), 1),
          _createTextVNode("\" assignment status: ")
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getResponsesByProductId(
            addon.productBucketId
          ), (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              (item.status)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(item.userEmail) + " was assigned successfully. ", 1))
                : _createCommentVNode("", true),
              (!item.status)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(item.userEmail) + " assignment failed: " + _toDisplayString(item.error), 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}